import React from "react";

const Card = ({ children }) => {
    return(
        <div className="p-2 md:p-3 border border-slate-400 rounded-lg shadow-md shadow-slate-500 bg-white">
            {children}
        </div>
    )
};

export default Card;